<template>
  <div class="h-full modal w-full">
    <div class="modal-content">
      <h1
        class="w-full mb-6 text-xl font-semibold tracking-wide text-gray-800 uppercase"
      >
        Details zu Landingpages/Widgets
      </h1>
      <h2 class="mt-5 mb-2">
        Überblick
      </h2>
      <div class="wrapper flex flex-wrap items-start gap-4">
        <div class="table-wrapper p-4 border rounded-lg shadow bg-white">
          <table class="w-full text-sm mt-4">
            <tbody class="text-gray-800">
              <tr class="border-t border-gray-200">
                <td
                  class="py-2"
                >
                  Aufrufe insgesamt
                </td>
                <td class="text-right font-medium">
                  {{ analyticsImpression?.overallTotal?.toLocaleString() || 0 }}
                </td>
              </tr>
              <tr class="border-t border-gray-200">
                <td
                  class="py-2"
                >
                  Aufrufe in den letzten 30 Tagen
                </td>
                <td class="text-right font-medium">
                  {{ analyticsImpression?.last30DaysTotal?.toLocaleString() || 0 }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template v-if="totalTrafficByUtmSourceForCompany?.length > 0">
        <h2 class="mt-5 mb-2">
          Gesamter Traffic nach UTM-Parametern
        </h2>
        <div class="wrapper flex flex-wrap items-start gap-4">
          <div
            v-for="(row, index) in totalTrafficByUtmSourceForCompany"
            :key="index"
            class="table-wrapper p-4 border rounded-lg shadow bg-white"
          >
            <h2>{{ row.label }}</h2>
            <table
              v-for="(item, i) in row.values"
              :key="i"
              class="w-full text-sm mt-4"
            >
              <tbody class="text-gray-800">
                <tr class="border-t border-gray-200">
                  <td
                    class="py-2"
                  >
                    {{ item.label }}
                  </td>
                  <td

                    class="text-right font-medium"
                  >
                    {{ item.value?.toLocaleString() || 0 }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>

      <template v-if="totalTrafficBySourceForCompany?.length > 0">
        <h2 class="mt-5 mb-0">
          Traffic nach Quellen unterteilt
        </h2>
        <div class="wrapper flex flex-wrap items-start gap-4">
          <div class="table-wrapper p-4 border rounded-lg shadow bg-white">
            <table class="w-full text-sm mt-4">
              <tbody class="text-gray-800">
                <tr
                  v-for="(row, index) in totalTrafficBySourceForCompany"
                  :key="index"
                  class="border-t border-gray-200"
                >
                  <td
                    class="py-2"
                  >
                    {{ row.label }}
                  </td>
                  <td
                    class="text-right font-medium"
                  >
                    {{ row.value?.toLocaleString() || 0 }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </div>

    <div class="modal-footer">
      <button
        class="btn-inline"
        @click="$emit('close')"
      >
        Abbrechen
      </button>
    </div>
  </div>
</template>

<script>
import TOTAL_TRAFFIC_BY_SOURCE_FOR_COMPANY from '@/components/company/queries/TotalTrafficBySourceForCompany.gql'
import TOTAL_TRAFFIC_BY_UTM_SOURCE_FOR_COMPANY from '@/components/company/queries/TotalTrafficByUtmSourceForCompany.gql'
import { capitalizeFirstLetter } from '@/lib/capitalize'

export default {
  props: {
    analyticsImpression: {
      type: Object,
      default: () => ({})
    },
    companyId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      textKindStatistics: [],
      topicStatistics: []
    }
  },
  apollo: {
    totalTrafficBySourceForCompany: {
      query: TOTAL_TRAFFIC_BY_SOURCE_FOR_COMPANY,
      variables () {
        return {
          input: {
            companyId: this.companyId
          }
        }
      },
      fetchPolicy: 'cache-and-network',
      update (data) {
        if (data.totalTrafficBySourceForCompany) {
          const readableItems = data.totalTrafficBySourceForCompany?.filter((item) => item.source)
            .map((item) => ({
              label: capitalizeFirstLetter(item.source),
              value: item.count
            })) || []

          const result = [...readableItems]

          const total = data.totalTrafficBySourceForCompany?.find(
            (item) => !item.source
          )
          const directSources = total ? { label: 'utm-direct', value: total.count } : null

          if (directSources) {
            result.push(directSources)
          }

          return result.sort((a, b) => b.value - a.value)
        }
        return []
      }
    },
    totalTrafficByUtmSourceForCompany: {
      query: TOTAL_TRAFFIC_BY_UTM_SOURCE_FOR_COMPANY,
      variables () {
        return {
          input: {
            companyId: this.companyId
          }
        }
      },
      fetchPolicy: 'cache-and-network',
      update (data) {
        if (data.totalTrafficByUtmSourceForCompany) {
          return data.totalTrafficByUtmSourceForCompany?.map((item) => {
            return {
              label: 'utm-' + item.utmKey,
              values: item.values.map((value) => ({
                label: value.label,
                value: value.count
              }))
            }
          }).sort((a, b) => {
            const sum = (arr) => arr.reduce((acc, v) => acc + v.value, 0)
            return sum(b.values) - sum(a.values)
          })
        }
        return []
      }
    }
  }
}
</script>
<style scoped>
.table-wrapper table {
  height: auto;
}
.wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1rem;
}
.table-wrapper {
  flex: 0 0 320px;
}

</style>
